import { Box } from "@mui/system";
import { Link, Menu, MenuItem } from "@mui/material";
import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { UIIconButton } from "../../CommonUI/BuildlingBlocks/UIIconButton";
import { TextEditorRegistration } from "../Utilities/RegisterTextEditor";
import { TextMergeEditContext } from "../../rule-engine-core/TextMerge/TextMergeEditContext";
import { TextElementRegistration } from "../../rule-engine-core/TextMerge/RegisterTextElement";

export const TextEditorActions = (props: { editContext: TextMergeEditContext }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
        >
            <Box
                paddingLeft={"30px"}
                display={"flex"}
                flexDirection={"row"}
            >
                <UIIconButton
                    icon={<KeyboardArrowUpIcon />}
                    onClick={() => {
                        props.editContext.moveUp();
                    }}
                />
                <UIIconButton
                    icon={<KeyboardArrowDownIcon />}
                    onClick={() => {
                        props.editContext.moveDown();
                    }}
                />
                <UIIconButton
                    icon={<DeleteOutlinedIcon />}
                    onClick={() => {
                        props.editContext.deleteSelected();
                    }}
                />
            </Box>

            <Link
                paddingRight={"5px"}
                key={"add"}
                onClick={handleClick}
            >
                Add
            </Link>
            {open && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {TextElementRegistration.getAllElements()
                        .filter((e) => {
                            return e.example.canAdd(props.editContext.definition);
                        })
                        .map((e) => {
                            let editor = TextEditorRegistration.getExpressionByTypeName(e.type)?.create(e.example);
                            return (
                                <MenuItem
                                    key={e.name}
                                    onClick={() => {
                                        props.editContext.addElement(e.type, "inline");
                                    }}
                                >
                                    {editor?.getIcon()}
                                    &nbsp;
                                    {e.name}
                                </MenuItem>
                            );
                        })}
                </Menu>
            )}
        </Box>
    );
};
